
import Vue from "vue";
import Component from "vue-class-component";
import Listas from "@/models/lists/listas.model"
import {ClienteFilter} from "@/models/cliente/cliente-filter.interface";
import ClienteService from "@/service/cliente.service";
import ClienteModel from "@/models/cliente/cliente.model";
import FormatUtil from "@/util/format.util";
import AcompanhamentoComponent from "@/components/AcompanhamentoComponent.vue";
import SyncModel from "@/models/cliente/sync.model";
import {namespace} from "vuex-class";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";
import DescricaoID from "@/models/lists/descricao-id.model";
import EnderecoService from "@/service/endereco.service";

const loading = namespace('loading');

@Component({
  name: "ClientesInicio",
  components: {
    AcompanhamentoComponent
  }
})
export default class ClientesInicio extends Vue {

  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private format = FormatUtil;
  private listaClientes: Array<ClienteModel> = [];
  private listas = new Listas();
  private syncModel = new SyncModel();
  private naoSincronizado = true;
  private filtro = {} as ClienteFilter;
  private openDelete = false;
  private openSync = false;
  private idSelecionado: number | null = null;
  private estados: Array<DescricaoID> = [];

  async pesquisar() {
    this.openLoading();
    this.listaClientes = await ClienteService.buscarComFiltro(this.filtro);
    this.closeLoading();
  }

  async deletar() {
    await ClienteService.delete(this.idSelecionado);
    this.openDelete = false;
    await this.getAll();
  }

  limpar() {
    this.filtro = {} as ClienteFilter;
  }

  async getAll() {
    this.openLoading();
    this.listaClientes = await ClienteService.buscarComFiltro(undefined);
    this.closeLoading();
  }

  converterTipoPessoa(tipo: string) {
    return tipo === 'J' ? 'Pessoa Jurídica' : tipo === 'F' ? 'Pessoa Física' : tipo;
  }

  goContato(item: ClienteModel) {
    this.$router.push(`cliente/${item.id}/sinalizar`);
  }

  goEdit(item: ClienteModel) {
    this.$router.push(`cliente/${item.id}`);
  }

  goAcompanhamento(item: ClienteModel) {
    this.$router.push(`acompanhamento/${item.id}`);
  }

  goDelete(item: ClienteModel) {
    this.idSelecionado = item.id;
    this.openDelete = true;
  }

  async goSync() {
    this.openSync = true;
    this.naoSincronizado = true;
    this.syncModel = await ClienteService.sync();
    this.naoSincronizado = false;
    await this.getAll();
  }

  formataData(dateTime: string) {
    const hora = dateTime.substring(11, 19);
    const [year, month, day] = dateTime.substring(0, 10).split('-');
    return `${day}/${month}/${year} ${hora}`;
  }

  formatarCnpjCpf() {
    this.filtro.cpf_cnpj = FormatUtil.cpfCnpj(this.filtro.cpf_cnpj);
  }

  async mounted() {
    this.estados = await EnderecoService.getEstados();
    this.getAll();
  }
}
